//@flow

import {
  LOGOUT,
  STORE_TOKEN,
  STORE_ERROR,
  REQUEST_LOGIN,
  INIT_USER_INFO,
  REGISTER_ACCOUNT,
  OPEN_LOGIN_MODAL,
  OPEN_SIGNUP_MODAL,
  CLOSE_LOGIN_MODAL,
  CLEAR_ALL_ERRORS,
  SIGNEDUP_SUCCESS,
  RESET_USER_DATA,
  LOGIN_SESSION_EXPIRE,
  STORE_USER_INFORMATION,
  SET_USER_ID,
  // FETCH_INVOICES,
  STORE_INVOICES,
  MASQUERADE_USER,
} from './types';
import type { Action } from '../../types/action';
import type { classicCredentials, oauthCredentials } from '../../types/auth';
import api from '../../lib/api';
import endpoints from '../../lib/endpoints';

export const openLoginModal = (): Action => {
  return { type: OPEN_LOGIN_MODAL };
};

export const openSignUpModal = (): Action => {
  return { type: OPEN_SIGNUP_MODAL };
};

export const closeAuthModal = (): Action => ({ type: CLOSE_LOGIN_MODAL });

export const requestLogin = (
  credentials: oauthCredentials | classicCredentials
): Action => ({ type: REQUEST_LOGIN, credentials });

export const registerAccount = (
  credentials: classicCredentials | oauthCredentials
): Action => ({
  type: REGISTER_ACCOUNT,
  credentials,
});

export const onSignupSuccess = (provider: string) => ({
  type: SIGNEDUP_SUCCESS,
  signedUpBy: provider,
});

export function setUserIdForAnalytics(userId: string) {
  return {
    type: SET_USER_ID,
    userId,
  };
}

export const storeToken = (token: string, userRole: string, id: string): Action => ({
  type: STORE_TOKEN,
  token,
  userRole,
  id,
});

export const initUserInfo = () => ({ type: INIT_USER_INFO });

export const storeUserInfo = (
  name: string,
  profileImages: Object<String>,
  primaryImage: string,
  connectedLodge: Array<string>,
  userId: string,
  isLeader: boolean,
  email: string,
  avatar: string
): Action => ({
  type: STORE_USER_INFORMATION,
  name,
  profileImages,
  primaryImage,
  userId,
  connectedLodge,
  isLeader,
  email,
  avatar,
});

export const reportError = (error: string): Action => ({
  type: STORE_ERROR,
  error,
});

export const clearError = (): Action => ({ type: CLEAR_ALL_ERRORS });

export const logout = (): Action => ({ type: LOGOUT });

export const resetUserData = (): Action => ({ type: RESET_USER_DATA });

export const loginSessionExpire = (sessionState: string): Action => ({
  type: LOGIN_SESSION_EXPIRE,
  sessionState,
});

export const fetchInvoices = () => async dispatch => {
  const { data } = await api.getWithToken(endpoints.payment.myInvoices);
  dispatch(storeInvoices(data));
};

export const storeInvoices = (invoices: Array<Object>) => ({
  type: STORE_INVOICES,
  invoices,
});

export const masqueradeAsUser = userId => ({
  type: MASQUERADE_USER,
  userId,
});



// WEBPACK FOOTER //
// ./src/redux/actions/authActions.js